import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import StatsStrip from "./components/StatsStrip";
import HotRanking from "./components/HotRanking";
import FermentStages from "./components/FermentStages";
import SpreadAnalysis from "./components/SpreadAnalysis";
import CaseGrid from "./components/CaseGrid";
import CategoryGrid from "./components/CategoryGrid";
import ReadGuide from "./components/ReadGuide";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import { hotEvents } from "@/mocks/events";
import { homeFaqs } from "@/mocks/faq";

const HOME_JSONLD = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "瓜链 · 网红黑曝传播追踪",
    alternateName: "瓜链",
    description:
      "聚焦网红黑曝发酵、上热搜、话题量与病毒传播路径的追踪平台，记录事件热度走势与扩散节点。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://gualian.example.com/events?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "瓜链",
    email: "info@gualian.example.com",
    description: "专注网红黑曝话题发酵与病毒传播路径的结构化记录平台。",
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "实时热搜追踪榜",
    itemListElement: hotEvents.slice(0, 8).map((event, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: event.title,
      url: `https://gualian.example.com/event/${event.id}`,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homeFaqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: { "@type": "Answer", text: faq.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="网红黑曝发酵与病毒传播追踪 - 热搜话题量与扩散路径 | 瓜链"
        description="网红黑曝是怎么一步步发酵扩散的？瓜链聚焦网红黑曝上热搜、转发与话题量变化，追踪病毒传播路径，记录事件热度走势与扩散节点，看懂一条爆料如何出圈。"
        keywords="网红黑曝,网红黑曝发酵,网红黑曝上热搜,网红黑曝话题量,网红黑曝病毒传播"
        canonicalPath="/"
        jsonLd={HOME_JSONLD}
      />
      <div className="min-h-screen bg-background-50">
        <SiteHeader />
        <main>
          <Hero />
          <StatsStrip />
          <HotRanking />
          <FermentStages />
          <SpreadAnalysis />
          <CaseGrid />
          <CategoryGrid />
          <ReadGuide />
          <FaqSection />
          <SubscribeSection />
        </main>
        <SiteFooter />
        <BackToTop />
      </div>
    </>
  );
}